import { ALICANTE_TRAVELOGUE_GALLERY } from "./alicanteTravelogueMedia";
import madridSegoviaSegoGallery from "./madridSegoviaSegoGallery.json";
import { SEGOVIA_TRAVELOGUE_MEDIA } from "./segoviaTravelogueMedia";
import {
  VALENCIA_TOUR,
  VALENCIA_TOUR_STATUS_TAG,
  mergeValenciaIfMissing,
} from "./valenciaTour";
import {
  ALICANTE_LISTOPAD_DE_DETAILED_INFO,
  ALICANTE_LISTOPAD_EN_DETAILED_INFO,
  ALICANTE_LISTOPAD_ES_DETAILED_INFO,
  ALICANTE_LISTOPAD_HR_DETAILED_INFO,
  mergeAlicanteListopadIfMissing,
} from "./alicanteListopadTour";
import {
  MADRID_VINOGRADA_DE_DETAILED_INFO,
  MADRID_VINOGRADA_EN_DETAILED_INFO,
  MADRID_VINOGRADA_ES_DETAILED_INFO,
  MADRID_VINOGRADA_HR_DETAILED_INFO,
  mergeMadridVinogradaIfMissing,
} from "./madridVinogradaTour";
import { ensureValladolidTourTranslations } from "./valladolidTours";

const ALICANTE_COVER = "/images/alicante.jpg";
/** Naslovnica + slike iz putopisa (public/images/alicante/) */
const ALICANTE_TOUR_GALLERY_BUILTIN = [ALICANTE_COVER, ...ALICANTE_TRAVELOGUE_GALLERY];

// Slike iz desktop mape „valladolid slike“ (public/images/valladolid/gallery/)
const VALLADOLID_GALLERY_DESKTOP = Array.from({ length: 14 }, (_, i) =>
  `/images/valladolid/gallery/gallery-${String(i + 1).padStart(2, "0")}.jpg`
);

// Slike iz desktop mape „madrid“ (public/images/madrid/gallery/)
const MADRID_GALLERY_DESKTOP = Array.from({ length: 7 }, (_, i) =>
  `/images/madrid/gallery/gallery-${String(i + 1).padStart(2, "0")}.jpg`
);

const MADRID_VINOGRADA_GALLERY_DESKTOP = [
  "/images/madrid-vinograda/1000108848.jpg",
  "/images/madrid-vinograda/1000149500.jpg",
  "/images/madrid-vinograda/1000149508.jpg",
  "/images/madrid-vinograda/1000149586.jpg",
  "/images/madrid-vinograda/segovialina.jpg",
];

const MADRID_LIPANJ_DVA_TERMINA_HR_DETAILED_INFO = `MADRID & SEGOVIA & mogućnost izleta u TOLEDO - city break koji spaja kulturu, gastronomiju i španjolsku energiju!

Tapas, Rooftops & Španjolska energija!
🗓 11.06. – 18.06. | 8 dana / 7 noćenja
🗓 11.06. – 15.06. | 5 dana / 4 noćenja

Doživite energiju španjolske prijestolnice kroz šetnje povijesnim trgovima, tapas kulturu i spektakularne rooftop terase. Ovaj city break vodi vas kroz najpoznatije dijelove Madrida te na izlet u bajkovitu Segoviu, grad poznat po rimskom akvaduktu i vrhunskoj gastronomiji.

Putujemo direktnim letom iz Zagreba s aviokompanijom Iberia ili Croatia Airlines uz smještaj u apartmanima 3★ u centru Madrida. Tijekom cijelog putovanja grupu prati voditelj putovanja na hrvatskom i španjolskom jeziku.

PROGRAM PUTOVANJA
1. DAN – ZAGREB – MADRID
Sastanak putnika u zračnoj luci Franjo Tuđman. Direktan let za Madrid, prtljaga 10kg uključena u cijenu, ukoliko ima potrebe za većom prtljagom od 23kg, mogućnost uz nadoplatu. Dolazak u Madrid i transfer do apartmana u centru grada.

U popodnevnim satima započinjemo pješački razgled povijesnog centra Madrida:
• Gran Vía
• Plaza Mayor
• Royal Palace of Madrid (uz nadoplatu)
• Puerta del Sol
• Mercado San Migel

Večera u tapas barovima u kvartu La Latina i druženje uz čašu dobrog španjolskog vina ili koktela na ulicama Madrida, te po želji odlazak na rooftop bar s nezaboravnim pogledom na Madrid. Rooftop je uključen u cijenu.

2. DAN – MADRID
Dan započinjemo odlaskom u tradicionalnu churreriju na churrose s toplom čokoladom. Nakon doručka odlazimo u elegantnu četvrt Salamanca i poznatu ulicu Calle de Serrano. Šetnja nas vodi do monumentalnih gradskih vrata Puerta de Alcalá i parka El Retiro Park.

Po želji moguć posjet muzejima uz nadoplatu:
• Prado Museum
• Museo Nacional Centro de Arte Reina Sofía
• stadion Santiago Bernabéu Stadium

U poslijepodnevnim satima posjet živopisnom kvartu Chueca, kvartu La Latina i mjestima po centru Madrida.

3. DAN – SEGOVIA
Izlet u povijesni grad Segovia. U jutarnjim satima ćemo se uputiti na Chamartin glavnu stanicu od kuda kreće vlak za Segoviu.

Razgled grada:
• Aqueduct of Segovia
• Alcázar of Segovia
• Segovia Cathedral
• Plaza Mayor

Povratak u Madrid u kasnijim satima.

4. DAN – MADRID
Slobodno vrijeme, stadion Santiago Bernabeu, rooftops.

5. DAN – TOLEDO
Mogućnost odlaska na jednodnevni izlet u Toledo uz nadoplatu.

6. DAN – MADRID
Slobodno vrijeme, Flamenco večer uz nadoplatu.

7. DAN – MADRID
Slobodno vrijeme.

8. DAN – MADRID – ZAGREB
Povratni let kući.

SMJEŠTAJ
Apartmani 3★ u centru Madrida
• potpuno opremljeni apartmani
• privatna kupaonica
• kuhinja
• WiFi
• bez doručka

CIJENA ARANŽMANA UKLJUČUJE
• povratni direktan let Zagreb – Madrid – Zagreb
• aerodromske pristojbe
• transfer aerodrom – smještaj – aerodrom
• 8 dana, 7 noćenja ili 5 dana, 4 noćenja u apartmanima 3★ u centru Madrida
• voditelja putovanja na hrvatskom i španjolskom jeziku
• organizaciju putovanja
• jednodnevni izlet vlakom u Segoviu

Ukupna cijena paket aranžmana 8 dana/7 noći: 1390,00€
Ukupna cijena paket aranžmana 5 dana/4 noći: 990,00€

Lipanj je jedno od najljepših razdoblja za posjet Madridu:
• ugodne proljetne temperature oko 20–25°C
• Park Retiro u punom sjaju
• tapas kultura na otvorenom
• živa atmosfera grada

Uvjeti plaćanja:
Za potvrdu rezervacije potrebno je uplatiti akontaciju u iznosu od 40% ukupne cijene aranžmana po osobi na broj računa HR7523400093207336956. Uplata akontacije smatra se potvrdom rezervacije i prihvaćanjem ponude. Preostali iznos potrebno je uplatiti najkasnije 20 dana prije polaska na putovanje.

Rezervacije i informacije:
Email: info@linatravelina.eu | Telefon: +385 91 214 447 7`;

const MADRID_LIPANJ_DVA_TERMINA_EN_DETAILED_INFO = `MADRID & SEGOVIA & optional TOLEDO excursion – a city break combining culture, gastronomy and Spanish energy!

Tapas, Rooftops & Spanish energy!
🗓 11.06. – 18.06. | 8 days / 7 nights
🗓 11.06. – 15.06. | 5 days / 4 nights

Experience the energy of Spain's capital through historic squares, tapas culture and spectacular rooftop terraces. This city break takes you through Madrid's highlights and to fairy-tale Segovia, known for its Roman aqueduct and excellent gastronomy.

We travel on direct flights from Zagreb with Iberia or Croatia Airlines, with accommodation in 3★ apartments in central Madrid. Throughout the trip, the group is accompanied by a tour leader in Croatian and Spanish.

ITINERARY
Day 1 – ZAGREB – MADRID
Meeting at Franjo Tudman Airport. Direct flight to Madrid; 10 kg luggage included, with an option to add 23 kg luggage for a supplement. Arrival in Madrid and transfer to city-center apartments.

Afternoon walking tour of Madrid's historic center:
• Gran Via
• Plaza Mayor
• Royal Palace of Madrid (optional supplement)
• Puerta del Sol
• Mercado San Miguel

Dinner in tapas bars in La Latina and social evening with Spanish wine or cocktails, with an optional rooftop bar visit. Rooftop is included in the price.

Day 2 – MADRID
Traditional churros breakfast with hot chocolate. After breakfast, visit the elegant Salamanca district and Calle de Serrano, then Puerta de Alcala and El Retiro Park.

Optional visits with supplement:
• Prado Museum
• Museo Nacional Centro de Arte Reina Sofia
• Santiago Bernabeu Stadium

Afternoon visit to Chueca, La Latina and central Madrid.

Day 3 – SEGOVIA
Day trip to historic Segovia by train from Chamartin station.

City tour:
• Aqueduct of Segovia
• Alcazar of Segovia
• Segovia Cathedral
• Plaza Mayor

Return to Madrid in the evening.

Day 4 – MADRID
Free time, Santiago Bernabeu, rooftops.

Day 5 – TOLEDO
Optional one-day excursion to Toledo (supplement).

Day 6 – MADRID
Free time, optional Flamenco evening.

Day 7 – MADRID
Free time.

Day 8 – MADRID – ZAGREB
Return flight home.

ACCOMMODATION
3★ apartments in central Madrid:
• fully equipped apartments
• private bathroom
• kitchen
• WiFi
• breakfast not included

PRICE INCLUDES
• return direct flight Zagreb – Madrid – Zagreb
• airport taxes
• airport – accommodation – airport transfer
• 8 days / 7 nights or 5 days / 4 nights in 3★ apartments in central Madrid
• tour leader in Croatian and Spanish
• trip organization
• one-day train excursion to Segovia

Total package price 8 days / 7 nights: €1,390.00
Total package price 5 days / 4 nights: €990.00

June is one of the best periods to visit Madrid:
• pleasant spring temperatures around 20–25°C
• Retiro Park in full bloom
• open-air tapas culture
• lively city atmosphere

PAYMENT TERMS
To confirm a booking, a 40% deposit per person must be paid to account HR7523400093207336956. The deposit confirms the reservation and acceptance of the offer. The remaining amount must be paid no later than 20 days before departure.

Bookings and information:
Email: info@linatravelina.eu | Phone: +385 91 214 447 7`;

const MADRID_LIPANJ_DVA_TERMINA_DE_DETAILED_INFO = `MADRID & SEGOVIA & optionaler Ausflug nach TOLEDO – City Break mit Kultur, Gastronomie und spanischer Energie!

Tapas, Rooftops & spanische Energie!
🗓 11.06. – 18.06. | 8 Tage / 7 Nächte
🗓 11.06. – 15.06. | 5 Tage / 4 Nächte

Erleben Sie die Energie der spanischen Hauptstadt durch Spaziergaenge ueber historische Plaetze, Tapas-Kultur und spektakulaere Rooftop-Terrassen. Dieser City Break fuehrt durch die bekanntesten Teile Madrids und nach Segovia, bekannt fuer das roemische Aquaedukt und hervorragende Gastronomie.

Wir reisen mit Direktfluegen ab Zagreb (Iberia oder Croatia Airlines) und uebernachten in 3★ Apartments im Zentrum Madrids. Waehrend der gesamten Reise begleitet die Gruppe eine Reiseleitung auf Kroatisch und Spanisch.

PROGRAMM
Tag 1 – ZAGREB – MADRID
Treffen am Flughafen Franjo Tudman. Direktflug nach Madrid, 10 kg Gepaeck inklusive; 23 kg gegen Aufpreis moeglich. Ankunft in Madrid und Transfer zu den Apartments im Stadtzentrum.

Nachmittags Stadtrundgang durch das historische Zentrum:
• Gran Via
• Plaza Mayor
• Royal Palace of Madrid (gegen Aufpreis)
• Puerta del Sol
• Mercado San Miguel

Abendessen in Tapas-Bars in La Latina und gemeinsamer Abend bei spanischem Wein oder Cocktails; auf Wunsch Rooftop-Bar. Rooftop ist im Preis enthalten.

Tag 2 – MADRID
Fruehstueck in einer traditionellen Churreria. Danach Besuch des eleganten Viertels Salamanca und der Calle de Serrano, weiter zu Puerta de Alcala und El Retiro Park.

Optionale Besuche gegen Aufpreis:
• Prado Museum
• Museo Nacional Centro de Arte Reina Sofia
• Santiago Bernabeu Stadium

Nachmittags Besuch von Chueca, La Latina und der Innenstadt.

Tag 3 – SEGOVIA
Tagesausflug nach Segovia mit dem Zug ab Chamartin.

Stadtbesichtigung:
• Aqueduct of Segovia
• Alcazar of Segovia
• Segovia Cathedral
• Plaza Mayor

Rueckkehr nach Madrid am Abend.

Tag 4 – MADRID
Freie Zeit, Santiago Bernabeu, Rooftops.

Tag 5 – TOLEDO
Moeglicher eintaeiger Ausflug nach Toledo (gegen Aufpreis).

Tag 6 – MADRID
Freie Zeit, Flamenco-Abend optional.

Tag 7 – MADRID
Freie Zeit.

Tag 8 – MADRID – ZAGREB
Rueckflug nach Hause.

UNTERKUNFT
3★ Apartments im Zentrum Madrids:
• voll ausgestattete Apartments
• privates Badezimmer
• Kueche
• WiFi
• ohne Fruehstueck

IM PREIS ENTHALTEN
• Direktflug Zagreb – Madrid – Zagreb (hin und zurueck)
• Flughafengebuehren
• Transfer Flughafen – Unterkunft – Flughafen
• 8 Tage / 7 Naechte oder 5 Tage / 4 Naechte in 3★ Apartments im Zentrum
• Reiseleitung auf Kroatisch und Spanisch
• Reiseorganisation
• eintaeiger Zugausflug nach Segovia

Gesamtpreis Paket 8 Tage / 7 Naechte: 1.390,00 €
Gesamtpreis Paket 5 Tage / 4 Naechte: 990,00 €

Der Juni ist eine der schoensten Zeiten fuer Madrid:
• angenehme Temperaturen um 20–25°C
• Retiro-Park in voller Pracht
• Tapas-Kultur im Freien
• lebendige Stadtatmosphaere

ZAHLUNGSBEDINGUNGEN
Zur Bestaetigung der Reservierung ist eine Anzahlung von 40 % pro Person auf das Konto HR7523400093207336956 erforderlich. Die Anzahlung gilt als Reservierungsbestaetigung und Annahme des Angebots. Der Restbetrag ist spaetestens 20 Tage vor Abreise zu zahlen.

Reservierungen und Informationen:
E-Mail: info@linatravelina.eu | Telefon: +385 91 214 447 7`;

const MADRID_LIPANJ_DVA_TERMINA_ES_DETAILED_INFO = `MADRID & SEGOVIA & posibilidad de excursión a TOLEDO - city break que combina cultura, gastronomía y energía española.

Tapas, Rooftops y energía española.
🗓 11.06. – 18.06. | 8 días / 7 noches
🗓 11.06. – 15.06. | 5 días / 4 noches

Vive la energía de la capital española recorriendo plazas históricas, disfrutando de la cultura de tapas y de espectaculares terrazas rooftop. Este city break te lleva por los lugares más conocidos de Madrid y a la ciudad de cuento Segovia, famosa por su acueducto romano y su excelente gastronomía.

Viajamos en vuelos directos desde Zagreb con Iberia o Croatia Airlines y nos alojamos en apartamentos 3★ en el centro de Madrid. Durante todo el viaje, el grupo cuenta con acompañante en croata y español.

PROGRAMA DE VIAJE
Día 1 – ZAGREB – MADRID
Encuentro en el aeropuerto Franjo Tudman. Vuelo directo a Madrid; equipaje de 10 kg incluido, con opción de 23 kg con suplemento. Llegada a Madrid y traslado a los apartamentos del centro.

Por la tarde, visita a pie del centro histórico:
• Gran Via
• Plaza Mayor
• Royal Palace of Madrid (con suplemento)
• Puerta del Sol
• Mercado San Miguel

Cena en bares de tapas del barrio La Latina y tiempo para socializar con vino español o cócteles; opcionalmente rooftop bar. El rooftop está incluido en el precio.

Día 2 – MADRID
Comenzamos con churros con chocolate en una churrería tradicional. Después, visita al elegante barrio Salamanca y a la calle Serrano, continuando hacia Puerta de Alcala y El Retiro Park.

Visitas opcionales con suplemento:
• Prado Museum
• Museo Nacional Centro de Arte Reina Sofia
• Santiago Bernabeu Stadium

Por la tarde, visita de Chueca, La Latina y el centro de Madrid.

Día 3 – SEGOVIA
Excursión de un día a Segovia en tren desde Chamartin.

Visita de la ciudad:
• Aqueduct of Segovia
• Alcazar of Segovia
• Segovia Cathedral
• Plaza Mayor

Regreso a Madrid por la tarde.

Día 4 – MADRID
Tiempo libre, Santiago Bernabeu, rooftops.

Día 5 – TOLEDO
Posibilidad de excursión de un día a Toledo (con suplemento).

Día 6 – MADRID
Tiempo libre, noche de flamenco opcional.

Día 7 – MADRID
Tiempo libre.

Día 8 – MADRID – ZAGREB
Vuelo de regreso.

ALOJAMIENTO
Apartamentos 3★ en el centro de Madrid:
• apartamentos totalmente equipados
• baño privado
• cocina
• WiFi
• sin desayuno

EL PRECIO INCLUYE
• vuelo directo ida y vuelta Zagreb – Madrid – Zagreb
• tasas aeroportuarias
• traslado aeropuerto – alojamiento – aeropuerto
• 8 días / 7 noches o 5 días / 4 noches en apartamentos 3★ en el centro
• acompañante de viaje en croata y español
• organización del viaje
• excursión de un día en tren a Segovia

Precio total paquete 8 días / 7 noches: 1.390,00 €
Precio total paquete 5 días / 4 noches: 990,00 €

Junio es una de las mejores épocas para visitar Madrid:
• temperaturas agradables de primavera, alrededor de 20–25°C
• Parque del Retiro en su mejor momento
• cultura de tapas al aire libre
• ambiente urbano muy vivo

CONDICIONES DE PAGO
Para confirmar la reserva, se debe abonar un anticipo del 40 % por persona en la cuenta HR7523400093207336956. El anticipo confirma la reserva y la aceptación de la oferta. El importe restante debe abonarse como máximo 20 días antes de la salida.

Reservas e información:
Email: info@linatravelina.eu | Teléfono: +385 91 214 447 7`;

// Slike i video iz desktop mape „sego“ — ažuriraj: npm run sync-sego
const MADRID_SEGOVIA_SEGO_MEDIA = Array.isArray(madridSegoviaSegoGallery)
  ? madridSegoviaSegoGallery
  : [];

/** Iste datoteke kao u putopisu Segovia — ne duplirati ako su već u galeriji (npr. /images/segovia.jpg). */
const SEGOVIA_IMAGE_ROOT_ALIASES = [
  ["/images/segovia.jpg", "/images/segovia/segovia.jpg"],
  ["/images/segovia1.jpg", "/images/segovia/segovia1.jpg"],
  ["/images/segovia2.jpg", "/images/segovia/segovia2.jpg"],
];

function expandSegoviaPathAliases(p) {
  const out = new Set([p]);
  for (const [root, folder] of SEGOVIA_IMAGE_ROOT_ALIASES) {
    if (p === root || p === folder) {
      out.add(root);
      out.add(folder);
    }
  }
  return out;
}

function overlapsTravelogueSegoviaMedia(p) {
  const pExp = expandSegoviaPathAliases(p);
  for (const m of SEGOVIA_TRAVELOGUE_MEDIA) {
    const mExp = expandSegoviaPathAliases(m);
    for (const a of pExp) {
      if (mExp.has(a)) return true;
    }
  }
  return false;
}

function segoviaTravelogueExtrasNotOnTour(tourPathsSoFar) {
  const seen = new Set();
  for (const p of tourPathsSoFar) {
    for (const x of expandSegoviaPathAliases(p)) seen.add(x);
  }
  return SEGOVIA_TRAVELOGUE_MEDIA.filter((p) => !seen.has(p));
}

function madridSegoviaBuiltinGallery() {
  const cover = "/images/madrid/1000107769.jpg";
  return [cover, ...MADRID_GALLERY_DESKTOP, ...MADRID_SEGOVIA_SEGO_MEDIA];
}

function ensureMadridJuneTours(tours) {
  if (!Array.isArray(tours) || tours.length === 0) return tours;
  const cleaned = tours.filter(
    (t) => t?.key !== "madrid-11-15-lipanj" && t?.key !== "madrid-11-18-lipanj"
  );
  const base = cleaned.find((t) => t?.key === "madrid-segovia");
  if (!base) return tours;

  const mergedKey = "madrid-lipanj-dva-termina";
  const existingMerged = cleaned.find((t) => t?.key === mergedKey);
  if (existingMerged) {
    return cleaned.map((tour) => {
      if (tour?.key !== mergedKey) return tour;
      return {
        ...tour,
        tag: "Last Minute",
        detailedInfo: {
          ...(tour.detailedInfo || {}),
          hr: MADRID_LIPANJ_DVA_TERMINA_HR_DETAILED_INFO,
          en: MADRID_LIPANJ_DVA_TERMINA_EN_DETAILED_INFO,
          de: MADRID_LIPANJ_DVA_TERMINA_DE_DETAILED_INFO,
          es: MADRID_LIPANJ_DVA_TERMINA_ES_DETAILED_INFO,
        },
      };
    });
  }

  const nextId = Math.max(0, ...cleaned.map((t) => Number(t?.id) || 0)) + 1;
  const mergedTour = {
    ...base,
    id: nextId,
    key: mergedKey,
    date: "2026-06-11",
    days: 8,
    nights: 7,
    price: 990,
    tag: "Last Minute",
    blogText: { ...(base.blogText || { hr: "", en: "", de: "", es: "" }) },
    detailedInfo: {
      ...(base.detailedInfo || { hr: "", en: "", de: "", es: "" }),
      hr: MADRID_LIPANJ_DVA_TERMINA_HR_DETAILED_INFO,
      en: MADRID_LIPANJ_DVA_TERMINA_EN_DETAILED_INFO,
      de: MADRID_LIPANJ_DVA_TERMINA_DE_DETAILED_INFO,
      es: MADRID_LIPANJ_DVA_TERMINA_ES_DETAILED_INFO,
    },
    gallery: Array.isArray(base.gallery) ? [...base.gallery] : [],
  };
  return [...cleaned, mergedTour];
}

function ensureFullDetailedInfoByLanguage(tours) {
  if (!Array.isArray(tours)) return tours;
  return tours.map((tour) => {
    if (!tour || !tour.key) return tour;

    const isAlicante = String(tour.key).startsWith("alicante");
    const isValladolid = String(tour.key).startsWith("valladolid");
    const isMadrid = String(tour.key).startsWith("madrid") || String(tour.key).includes("madrid");
    if (!isAlicante && !isValladolid && !isMadrid) return tour;

    const detailedInfo = tour.detailedInfo || { hr: "", en: "", de: "", es: "" };
    const hrText = (detailedInfo.hr || "").trim();
    if (!hrText) return tour;

    const ensureLongText = (value) => {
      const text = (value || "").trim();
      // Ako je prijevod kratak/sažet, koristi puni tekst kao na HR.
      return text.length >= Math.floor(hrText.length * 0.6) ? text : hrText;
    };

    return {
      ...tour,
      detailedInfo: {
        ...detailedInfo,
        en: ensureLongText(detailedInfo.en),
        de: ensureLongText(detailedInfo.de),
        es: ensureLongText(detailedInfo.es),
      },
    };
  });
}

// Funkcija za učitavanje iz localStorage ili vraćanje default vrijednosti
export const loadTours = () => {
  const saved = localStorage.getItem("travelina_tours");
  if (saved) {
    try {
      const tours = JSON.parse(saved).filter((t) => t?.key !== "valladolid");
      // Ažuriraj putanje slika ako su stare
      return ensureValladolidTourTranslations(
        ensureFullDetailedInfoByLanguage(
          ensureMadridJuneTours(
            mergeMadridVinogradaIfMissing(
              mergeValenciaIfMissing(
                mergeAlicanteListopadIfMissing(
                  tours.map((tour) => {
        if (tour.key === "alicante" && tour.image !== "/images/alicante.jpg") {
          tour.image = "/images/alicante.jpg";
        }
        if (tour.key === "alicante") {
          tour.tag = "Popunjeno";
        }
        if (tour.key === "alicante-maj" && tour.image !== "/images/alicante.jpg") {
          tour.image = "/images/alicante.jpg";
        }
        if (tour.key === "alicante-maj") {
          tour.tag = "Popunjeno";
        }
        if (tour.key === "alicante-ozujak" && tour.image !== "/images/alicante.jpg") {
          tour.image = "/images/alicante.jpg";
        }
        if (tour.key === "alicante-ozujak") {
          tour.tag = "Popunjeno";
        }
        if (tour.key === "madrid-segovia" && !tour.image) {
          tour.image = "/images/madrid/1000107769.jpg";
        }
        if (tour.key === "madrid-segovia") {
          tour.tag = "Popunjeno";
        }
        if (tour.key === "madrid-lipanj-dva-termina") {
          tour.tag = "Last Minute";
        }
        if (tour.key === "valladolid-1tjedan-lipanj" || tour.key === "valladolid-2tjedan-lipanj") {
          tour.tag = "Last Minute";
        }
        if (tour.key === "madrid-vinograda") {
          tour.key = "od-madrida-do-vinograda";
        }
        if (tour.key === "od-madrida-do-vinograda" && !tour.image) {
          tour.image = "/images/madrid-vinograda/1000149586.jpg";
        }
        if (
          (tour.key === "valladolid-1tjedan" || tour.key === "valladolid-1tjedan-lipanj") &&
          tour.image !== "/images/valladolid.jpeg"
        ) {
          tour.image = "/images/valladolid.jpeg";
        }
        if (
          (tour.key === "valladolid-2tjedan" || tour.key === "valladolid-2tjedan-lipanj") &&
          tour.image !== "/images/valladolid.jpeg"
        ) {
          tour.image = "/images/valladolid.jpeg";
        }
        // Osiguraj da blogText postoji
        if (!tour.blogText) {
          tour.blogText = { hr: "", en: "", de: "", es: "" };
        }
        // Osiguraj da detailedInfo postoji
        if (!tour.detailedInfo) {
          tour.detailedInfo = { hr: "", en: "", de: "", es: "" };
        }
        // Osiguraj da gallery postoji i da je array
        if (!tour.gallery || !Array.isArray(tour.gallery)) {
          tour.gallery = [];
        }
        if (
          tour.key === "valladolid-1tjedan" ||
          tour.key === "valladolid-2tjedan" ||
          tour.key === "valladolid-1tjedan-lipanj" ||
          tour.key === "valladolid-2tjedan-lipanj"
        ) {
          const g = tour.gallery;
          const tail = g.filter(
            (p) =>
              p !== "/images/valladolid.jpeg" && !p.includes("/valladolid/gallery/")
          );
          tour.gallery = ["/images/valladolid.jpeg", ...VALLADOLID_GALLERY_DESKTOP, ...tail];
        }
        if (tour.key === "madrid-segovia") {
          const cover = "/images/madrid/1000107769.jpg";
          const g = tour.gallery || [];
          const tail = g.filter(
            (p) =>
              p !== cover &&
              !p.includes("/madrid/gallery/") &&
              !p.includes("/madrid-segovia/sego/") &&
              !overlapsTravelogueSegoviaMedia(p)
          );
          const base = madridSegoviaBuiltinGallery();
          tour.gallery = [
            ...base,
            ...segoviaTravelogueExtrasNotOnTour(base),
            ...tail,
          ];
        }
        if (tour.key === "od-madrida-do-vinograda") {
          const g = tour.gallery || [];
          const tail = g.filter((p) => !p.includes("/madrid-vinograda/"));
          tour.gallery = [...MADRID_VINOGRADA_GALLERY_DESKTOP, ...tail];
        }
        if (
          tour.key === "alicante" ||
          tour.key === "alicante-maj" ||
          tour.key === "alicante-ozujak" ||
          tour.key === "alicante-listopad"
        ) {
          const g = tour.gallery || [];
          const tail = g.filter(
            (p) => p !== ALICANTE_COVER && !p.startsWith("/images/alicante/")
          );
          tour.gallery = [...ALICANTE_TOUR_GALLERY_BUILTIN, ...tail];
        }
        if (tour.key === "valencia") {
          tour.tag = VALENCIA_TOUR_STATUS_TAG;
          tour.image = VALENCIA_TOUR.image;
          tour.gallery = [...VALENCIA_TOUR.gallery];
        }
        if (tour.key === "valladolid-2tjedan" && tour.price === 2390) {
          tour.price = 2490;
        }
        if (tour.key === "alicante-maj" && tour.price !== 690) {
          tour.price = 690;
        }
        if (tour.key === "alicante-listopad" && tour.price !== 690) {
          tour.price = 690;
        }
        if (tour.key === "madrid-segovia" && tour.price !== 870) {
          tour.price = 870;
        }
        // Osiguraj da detailedInfo postoji
        if (!tour.detailedInfo) {
          tour.detailedInfo = { hr: "", en: "", de: "", es: "" };
        }
            return tour;
              }),
              ALICANTE_TOUR_GALLERY_BUILTIN
            )
          )
        ),
        MADRID_VINOGRADA_GALLERY_DESKTOP
      )
    )
  );
    } catch (e) {
      console.error("Error loading tours from localStorage", e);
    }
  }
  const defaultTours = [
    {
      id: 1,
      key: "alicante",
      category: "beach",
      days: 4,
      nights: 3,
      country: "Spain",
      date: "2026-04-16",
      price: 525,
      tag: "Popunjeno",
      image: "/images/alicante.jpg",
      blogText: { hr: "", en: "", de: "", es: "" },
      gallery: [...ALICANTE_TOUR_GALLERY_BUILTIN],
      detailedInfo: {
        hr: `ALICANTE – ESCAPADA DE PRIMAVERA – SPRING ESCAPE
Proljetni bijeg na Costa Blancu – vino, more i radionica paelle

🗓 16.04. – 19.04. (4 dana / 3 noći)

Zamislite grad u kojem palmama okružena šetnica vodi do zlatnih plaža, gdje se povijesni dvorac uzdiže iznad grada, a miris svježe pripremljene paelle širi uskim ulicama starog grada. Alicante, smješten na obali Costa Blance, jedan je od najsunčanijih gradova Španjolske.

💰 CIJENA PAKET ARANŽMANA
525,00 € po osobi
(Minimalno 10 osoba za ostvarenje putovanja)

✅ CIJENA UKLJUČUJE
• Direktni jutarnji letovi Zagreb–Alicante–Zagreb
• Ručna prtljaga uključena
• Smještaj u privatnim, moderno opremljenim apartmanima u blizini centra
• Transfer aerodrom – smještaj – aerodrom
• Radionica pripreme tradicionalne španjolske paelle
• Posjet dvorcu Santa Bárbara uz mogućnost degustacije vina
• Organizirana šetnja gradom i glavne znamenitosti

❌ CIJENA NE UKLJUČUJE
• Carry-on prtljaga (mogućnost nadoplate za mali kofer u kabini)
• Putno zdravstveno i osiguranje od otkaza (moguće uz nadoplatu)
• Dodatne aktivnosti (npr. izlet na otok Tabarca)
• Ručkovi i večere (vlastiti aranžman)

📍 PROGRAM
1. DAN (16.04.) – Dolazak u Alicante
Ranojutarnji direktan let za Alicante. Transfer do apartmana. Popodne: Explanada de España, luka, marina, plaža Postiguet. Slobodna večer – tapas barovi.

2. DAN (17.04.) – Dvorac, vino i paella
Doručak churros i topla čokolada. Dvorac Santa Bárbara – razgled i degustacija vina. Popodne: radionica pripreme tradicionalne paelle. Slobodna večer.

3. DAN (18.04.) – Mediteranski ritam
Mercado Central, Calle de las Setas, Barrio Santa Cruz, MARQ (Arheološki muzej). Popodne slobodno. Opcionalno: izlet brodom na Tabarcu (uz doplatu). Slobodna večer.

4. DAN (19.04.) – Povratak
Transfer u ranim jutarnjim satima. Direktan let za Zagreb. Dolazak u prijepodnevnim satima.

🏛 ZNAMENITOSTI
Dvorac Santa Bárbara • Explanada de España • Mercado Central • Barrio Santa Cruz • Calle de las Setas • Plaža Postiguet • Luka • Otok Tabarca

💳 UVJETI PLAĆANJA
Akontacija 40% na HR7523400093207336956 za potvrdu. Preostali iznos najkasnije 10 dana prije polaska.

📞 Rezervacije: info@linatravelina.eu | +385 91 214 447 7
TraveLina – putovanja koja se pamte!`,
        en: `ALICANTE – ESCAPADA DE PRIMAVERA – SPRING ESCAPE
Spring escape to the Costa Blanca – wine, sea and paella workshop

🗓 16–19 April (4 days / 3 nights)

Imagine a city where a palm-lined promenade leads to golden beaches, a historic castle rises above the town, and the scent of freshly prepared paella fills the narrow streets of the old quarter. Alicante, on the Costa Blanca, is one of Spain’s sunniest cities.

💰 PACKAGE PRICE
€525.00 per person
(Minimum 10 people for the trip to run)

✅ PRICE INCLUDES
• Direct morning flights Zagreb–Alicante–Zagreb
• Hand luggage included
• Accommodation in private, modern apartments near the centre
• Airport–accommodation–airport transfer
• Traditional Spanish paella workshop
• Visit to Santa Bárbara Castle with optional wine tasting
• Guided city walk and main sights

❌ NOT INCLUDED
• Carry-on luggage (supplement for cabin bag)
• Travel and cancellation insurance (available at extra cost)
• Optional activities (e.g. boat trip to Tabarca Island)
• Lunches and dinners (own arrangement)

📍 PROGRAMME
Day 1 (16 Apr) – Arrival in Alicante
Morning direct flight. Transfer to apartments. Afternoon: Explanada de España, port, marina, Postiguet beach. Free evening – tapas bars.

Day 2 (17 Apr) – Castle, wine and paella
Breakfast: churros and hot chocolate. Santa Bárbara Castle – tour and wine tasting. Afternoon: traditional paella workshop. Free evening.

Day 3 (18 Apr) – Mediterranean pace
Mercado Central, Calle de las Setas, Barrio Santa Cruz, MARQ (Archaeological Museum). Free afternoon. Optional: boat trip to Tabarca (supplement). Free evening.

Day 4 (19 Apr) – Return
Early morning transfer. Direct flight to Zagreb. Morning arrival.

🏛 HIGHLIGHTS
Santa Bárbara Castle • Explanada de España • Mercado Central • Barrio Santa Cruz • Calle de las Setas • Postiguet Beach • Port • Tabarca Island

💳 PAYMENT
40% deposit to HR7523400093207336956 to confirm. Balance due at latest 10 days before departure.

📞 Bookings: info@linatravelina.eu | +385 91 214 447 7
TraveLina – trips to remember!`,
        de: `ALICANTE – ESCAPADA DE PRIMAVERA – SPRING ESCAPE
Frühlingsflucht an die Costa Blanca – Wein, Meer und Paella-Workshop

🗓 16.–19.04. (4 Tage / 3 Nächte)

Stellen Sie sich eine Stadt vor, in der eine Palmenallee zu goldenen Stränden führt, eine historische Burg über der Stadt thront und der Duft von frischer Paella die engen Gassen der Altstadt erfüllt. Alicante an der Costa Blanca ist eine der sonnigsten Städte Spaniens.

💰 PAKETPREIS
525,00 € pro Person
(Mindestens 10 Personen für die Durchführung der Reise)

✅ IM PREIS ENTHALTEN
• Direkte Morgenflüge Zagreb–Alicante–Zagreb
• Handgepäck inklusive
• Unterkunft in privaten, modernen Apartments in Zentrumsnähe
• Transfer Flughafen–Unterkunft–Flughafen
• Workshop traditionelle spanische Paella
• Besuch Castillo de Santa Bárbara mit optionaler Weinverkostung
• Geführter Stadtspaziergang und Hauptsehenswürdigkeiten

❌ NICHT ENTHALTEN
• Handgepäck (Aufpreis für Kabinenkoffer)
• Reise- und Stornoversicherung (gegen Aufpreis)
• Optionale Aktivitäten (z. B. Bootsausflug zur Insel Tabarca)
• Mittag- und Abendessen (eigene Arrangement)

📍 PROGRAMM
Tag 1 (16.04.) – Ankunft in Alicante
Morgendlicher Direktflug. Transfer zu den Apartments. Nachmittag: Explanada de España, Hafen, Marina, Strand Postiguet. Freier Abend – Tapas-Bars.

Tag 2 (17.04.) – Burg, Wein und Paella
Frühstück: Churros und heiße Schokolade. Castillo de Santa Bárbara – Besichtigung und Weinverkostung. Nachmittag: Paella-Workshop. Freier Abend.

Tag 3 (18.04.) – Mediterranes Tempo
Mercado Central, Calle de las Setas, Barrio Santa Cruz, MARQ (Archäologisches Museum). Freier Nachmittag. Optional: Bootsausflug nach Tabarca (Aufpreis). Freier Abend.

Tag 4 (19.04.) – Rückreise
Transfer in den frühen Morgenstunden. Direktflug nach Zagreb. Ankunft am Vormittag.

🏛 HIGHLIGHTS
Santa Bárbara • Explanada de España • Mercado Central • Barrio Santa Cruz • Calle de las Setas • Strand Postiguet • Hafen • Insel Tabarca

💳 ZAHLUNG
40 % Anzahlung auf HR7523400093207336956 zur Bestätigung. Restbetrag spätestens 10 Tage vor Abreise.

📞 Buchung: info@linatravelina.eu | +385 91 214 447 7
TraveLina – Reisen, die in Erinnerung bleiben!`,
        es: `ALICANTE – ESCAPADA DE PRIMAVERA – SPRING ESCAPE
Escape primaveral a la Costa Blanca – vino, mar y taller de paella

🗓 16–19 de abril (4 días / 3 noches)

Imagina una ciudad donde un paseo entre palmeras lleva a playas doradas, un castillo histórico domina la ciudad y el aroma de la paella recién hecha llena las calles del casco antiguo. Alicante, en la Costa Blanca, es una de las ciudades más soleadas de España.

💰 PRECIO DEL PAQUETE
525,00 € por persona
(Mínimo 10 personas para realizar el viaje)

✅ INCLUIDO EN EL PRECIO
• Vuelos directos de mañana Zagreb–Alicante–Zagreb
• Equipaje de mano incluido
• Alojamiento en apartamentos privados y modernos cerca del centro
• Transfer aeropuerto–alojamiento–aeropuerto
• Taller de paella tradicional española
• Visita al Castillo de Santa Bárbara con degustación de vinos opcional
• Paseo guiado por la ciudad y principales puntos de interés

❌ NO INCLUIDO
• Equipaje de cabina (suplemento por maleta)
• Seguro de viaje y cancelación (disponible con suplemento)
• Actividades opcionales (p. ej. excursión en barco a la isla de Tabarca)
• Comidas y cenas (por cuenta del cliente)

📍 PROGRAMA
Día 1 (16 abr) – Llegada a Alicante
Vuelo directo por la mañana. Transfer a apartamentos. Tarde: Explanada de España, puerto, marina, playa del Postiguet. Noche libre – bares de tapas.

Día 2 (17 abr) – Castillo, vino y paella
Desayuno: churros y chocolate. Castillo de Santa Bárbara – visita y cata de vinos. Tarde: taller de paella. Noche libre.

Día 3 (18 abr) – Ritmo mediterráneo
Mercado Central, Calle de las Setas, Barrio Santa Cruz, MARQ (Museo Arqueológico). Tarde libre. Opcional: excursión en barco a Tabarca (suplemento). Noche libre.

Día 4 (19 abr) – Regreso
Transfer a primera hora. Vuelo directo a Zagreb. Llegada por la mañana.

🏛 LUGARES DESTACADOS
Castillo de Santa Bárbara • Explanada de España • Mercado Central • Barrio Santa Cruz • Calle de las Setas • Playa del Postiguet • Puerto • Isla de Tabarca

💳 PAGO
40 % de depósito en HR7523400093207336956 para confirmar. Resto como máximo 10 días antes de la salida.

📞 Reservas: info@linatravelina.eu | +385 91 214 447 7
TraveLina – ¡viajes que se recuerdan!`,
      },
    },
    {
      id: 3,
      key: "alicante-maj",
      category: "beach",
      days: 4,
      nights: 3,
      country: "Spain",
      date: "2026-05-07",
      price: 690,
      tag: "Popunjeno",
      image: "/images/alicante.jpg",
      blogText: { hr: "", en: "", de: "", es: "" },
      gallery: [...ALICANTE_TOUR_GALLERY_BUILTIN],
      detailedInfo: {
        hr: `ALICANTE – ESCAPADA DE PRIMAVERA – SPRING ESCAPE
Proljetni bijeg na Costa Blancu – vino, more i radionica paelle

🗓 07.05. – 10.05. (4 dana / 3 noći)

Zamislite grad u kojem palmama okružena šetnica vodi do zlatnih plaža, gdje se povijesni dvorac uzdiže iznad grada, a miris svježe pripremljene paelle širi uskim ulicama starog grada. Alicante, smješten na obali Costa Blance, jedan je od najsunčanijih gradova Španjolske. Grad spaja bogatu povijest, mediteranski način života, prekrasne plaže i izvrsnu gastronomiju. Uz živopisne tržnice, šarmantne kvartove i opuštenu atmosferu, Alicante je savršena destinacija za kratko, ali nezaboravno putovanje.

Zašto posjetiti Alicante u svibnju?
Svibanj je idealno vrijeme za posjet ovom mediteranskom gradu.
• Ugodna proljetna klima – temperature oko 20–24°C savršene su za istraživanje grada.
• Manje gužve nego u ljetnim mjesecima – grad se može doživjeti opuštenije.
• Savršeno vrijeme za gastronomiju i vinske rute.
• Idealno za šetnje uz more, razgledavanje i izlete brodom.
Proljeće u Alicanteu donosi sunce, miris mora i autentičnu španjolsku atmosferu.

💰 CIJENA PAKET ARANŽMANA
690,00 € po osobi
(Minimalno 8 osoba za ostvarenje putovanja)

✅ CIJENA UKLJUČUJE
• Direktni jutarnji letovi Ryanair Zagreb–Alicante–Zagreb
• Ručna prtljaga uključena u cijenu
• Smještaj u privatnim, moderno opremljenim apartmanima u blizini centra grada
• Transfer aerodrom – smještaj – aerodrom
• Radionica pripreme tradicionalne španjolske paelle
• Posjet dvorcu Santa Bárbara uz mogućnost degustacije vina
• Organizirana šetnja gradom i upoznavanje s glavnim znamenitostima

❌ CIJENA NE UKLJUČUJE
• Carry-on prtljaga – mogućnost nadoplate za mali kofer u kabini
• Putno zdravstveno osiguranje i osiguranje od otkaza (moguće uz nadoplatu)
• Dodatne aktivnosti i izleti (npr. izlet na otok Tabarca)
• Ručkovi i večere (vlastiti aranžman)

📍 PROGRAM PUTOVANJA
1. DAN – 10.05. Dolazak u Alicante
Ranojutarnji direktan let za Alicante. Transfer do apartmana. Popodne: Explanada de España, luka, marina, plaža Postiguet. Slobodno vrijeme za večeru i tapas barove.

2. DAN – 11.05. Dvorac, vino i španjolska kuhinja
Doručak churros i topla čokolada. Dvorac Santa Bárbara – razgled i degustacija lokalnih vina. Popodne: radionica pripreme tradicionalne paelle. Večer slobodna.

3. DAN – 12.05. Mediteranski ritam grada
Mercado Central, Calle de las Setas, Barrio Santa Cruz, MARQ (Arheološki muzej). Popodne slobodno za kupanje ili šetnju. Opcionalno: izlet brodom na otok Tabarca (uz doplatu). Večer slobodna.

4. DAN – 13.05. Povratak u Zagreb
Transfer u ranim jutarnjim satima. Direktan jutarnji let za Zagreb. Dolazak u prijepodnevnim satima.

🏛 ZNAMENITOSTI
Dvorac Santa Bárbara • Explanada de España • Mercado Central • Barrio Santa Cruz • Calle de las Setas • Plaža Postiguet • Luka Alicante • Otok Tabarca

💳 UVJETI PLAĆANJA
Akontacija 40% na HR7523400093207336956 za potvrdu. Preostali iznos najkasnije 10 dana prije polaska.

📞 Rezervacije i informacije
Email: info@linatravelina.eu | Telefon: +385 91 214 447 7

TraveLina – putovanja koja se pamte!`,
        en: `ALICANTE – ESCAPADA DE PRIMAVERA – SPRING ESCAPE
Spring escape to the Costa Blanca – wine, sea and paella workshop

🗓 7–10 May (4 days / 3 nights)

Alicante, on the Costa Blanca, is one of Spain's sunniest cities. May is the ideal time to visit – pleasant spring weather (20–24°C), fewer crowds, and perfect for gastronomy, wine and coastal walks.

💰 PACKAGE PRICE
€690.00 per person (minimum 8 people)

✅ PRICE INCLUDES
• Ryanair morning flights Zagreb–Alicante–Zagreb • Hand luggage • Accommodation in private apartments near the centre • Transfers • Paella workshop • Santa Bárbara Castle visit with wine tasting • Guided city walk

❌ NOT INCLUDED
• Carry-on luggage (supplement) • Travel insurance • Optional excursions (e.g. Tabarca) • Meals

📍 PROGRAMME
Day 1 (10 May) – Arrival, Explanada de España, port, marina, Postiguet beach. Day 2 (11 May) – Churros breakfast, Santa Bárbara Castle, paella workshop. Day 3 (12 May) – Mercado Central, Calle de las Setas, Barrio Santa Cruz, MARQ. Optional boat trip to Tabarca. Day 4 (13 May) – Morning transfer and flight to Zagreb.

💳 Payment: 40% deposit to HR7523400093207336956. Balance 10 days before departure.
📞 info@linatravelina.eu | +385 91 214 447 7 | TraveLina`,
        de: `ALICANTE – ESCAPADA DE PRIMAVERA – SPRING ESCAPE
Frühlingsausflug an die Costa Blanca – Wein, Meer und Paella-Workshop

🗓 7.–10. Mai (4 Tage / 3 Nächte)

Alicante an der Costa Blanca – im Mai mit angenehmem Frühjahrsklima (20–24°C), weniger Andrang und ideal für Gastronomie, Wein und Küstenspaziergänge.

💰 Paketpreis 690 € pro Person (mind. 8 Personen). Ryanair Zagreb–Alicante–Zagreb. Inkl. Unterkunft, Transfers, Paella-Workshop, Santa Bárbara, Stadtführung. Programm: Anreise 10.05., Burg & Paella 11.05., Mercado Central & MARQ 12.05., Rückflug 13.05.

💳 40 % Anzahlung auf HR7523400093207336956. Rest 10 Tage vor Abreise.
📞 info@linatravelina.eu | +385 91 214 447 7 | TraveLina`,
        es: `ALICANTE – ESCAPADA DE PRIMAVERA – SPRING ESCAPE
Escapada de primavera a la Costa Blanca – vino, mar y taller de paella

🗓 7–10 mayo (4 días / 3 noches)

Alicante, en la Costa Blanca – en mayo clima primaveral agradable (20–24°C), menos aglomeraciones, ideal para gastronomía, vino y paseos por la costa.

💰 Precio del paquete 690 € por persona (mín. 8 personas). Ryanair Zagreb–Alicante–Zagreb. Incl. alojamiento, traslados, taller de paella, Santa Bárbara, paseo guiado. Programa: llegada 10.05., castillo y paella 11.05., Mercado Central y MARQ 12.05., regreso 13.05.

💳 40 % depósito en HR7523400093207336956. Resto 10 días antes de la salida.
📞 info@linatravelina.eu | +385 91 214 447 7 | TraveLina`,
      },
    },
    {
      id: 7,
      key: "alicante-ozujak",
      category: "beach",
      days: 4,
      nights: 3,
      country: "Spain",
      date: "2026-03-07",
      price: 590,
      tag: "Popunjeno",
      image: "/images/alicante.jpg",
      blogText: { hr: "", en: "", de: "", es: "" },
      gallery: [...ALICANTE_TOUR_GALLERY_BUILTIN],
      detailedInfo: {
        hr: `ALICANTE – ESCAPADA DE PRIMAVERA – SPRING ESCAPE
Proljetni bijeg na Costa Blancu – ožujak – vino, more i radionica paelle

🗓 07.03. – 10.03.2026. (4 dana / 3 noći)

Isti program kao proljetni termin Ryanairom – Costa Blanca, apartmani uz centar, radionica paelle, dvorac Santa Bárbara, šetnja gradom. Rani proljetni termin u ožujku idealan za mirniji tempo i ugodne temperature.

💰 CIJENA PAKET ARANŽMANA
590,00 € po osobi
(Minimalno 8 osoba za ostvarenje putovanja)

✅ CIJENA UKLJUČUJE
• Direktni jutarnji letovi Ryanair Zagreb–Alicante–Zagreb
• Ručna prtljaga uključena u cijenu
• Smještaj u privatnim apartmanima u blizini centra
• Transfer aerodrom – smještaj – aerodrom
• Radionica pripreme tradicionalne paelle
• Posjet dvorcu Santa Bárbara (s degustacijom vina)
• Organizirana šetnja gradom

❌ CIJENA NE UKLJUČUJE
• Carry-on uz moguću nadoplatu • Osiguranje • Tabarca i ostalo izborno • Obroci

📍 PROGRAM (indikativno)
1. dan 07.03. – Dolazak, Explanada, luka, Postiguet
2. dan 08.03. – Santa Bárbara, radionica paelle
3. dan 09.03. – Mercado Central, Barrio Santa Cruz, MARQ
4. dan 10.03. – Povratak letom za Zagreb

💳 Akontacija 40% na HR7523400093207336956; ostatak do 10 dana prije polaska.
📞 info@linatravelina.eu | +385 91 214 4477 | TraveLina`,
        en: `ALICANTE – SPRING ESCAPE (March)
🗓 7–10 March 2026 (4 days / 3 nights) | Ryanair ZAG–ALC–ZAG | €590 pp (min. 8). Same spring programme as our May trip: apartments, paella workshop, Santa Bárbara, city walk. 40% deposit; balance 10 days before.
📞 info@linatravelina.eu | +385 91 214 4477 | TraveLina`,
        de: `ALICANTE – FRÜHLING (März)
🗓 7.–10. März 2026 (4 Tage / 3 Nächte) | Ryanair Zagreb–Alicante | 590 € p. P. (mind. 8). Gleiches Programm wie Mai-Termin.
📞 info@linatravelina.eu | +385 91 214 4477 | TraveLina`,
        es: `ALICANTE – PRIMAVERA (marzo)
🗓 7–10 mar 2026 (4 días / 3 noches) | Ryanair Zagreb–Alicante | 590 € p. persona (mín. 8). Mismo programa que el viaje de mayo.
📞 info@linatravelina.eu | +385 91 214 4477 | TraveLina`,
      },
    },
    {
      id: 12,
      key: "alicante-listopad",
      category: "beach",
      days: 4,
      nights: 3,
      country: "Spain",
      date: "2026-10-01",
      price: 690,
      tag: "New",
      image: "/images/alicante.jpg",
      blogText: { hr: "", en: "", de: "", es: "" },
      gallery: [...ALICANTE_TOUR_GALLERY_BUILTIN],
      detailedInfo: {
        hr: ALICANTE_LISTOPAD_HR_DETAILED_INFO,
        en: ALICANTE_LISTOPAD_EN_DETAILED_INFO,
        de: ALICANTE_LISTOPAD_DE_DETAILED_INFO,
        es: ALICANTE_LISTOPAD_ES_DETAILED_INFO,
      },
    },
    {
      id: 4,
      key: "madrid-segovia",
      category: "city",
      days: 4,
      nights: 3,
      country: "Spain",
      date: "2026-05-14",
      price: 870,
      tag: "Popunjeno",
      image: "/images/madrid/1000107769.jpg",
      blogText: { hr: "", en: "", de: "", es: "" },
      gallery: (() => {
        const base = madridSegoviaBuiltinGallery();
        return [...base, ...segoviaTravelogueExtrasNotOnTour(base)];
      })(),
      detailedInfo: {
        hr: `MADRID & SEGOVIA – CITY BREAK
Tapas, Rooftops & Španjolska energija!

🗓 14.05. – 17.05. (4 dana / 3 noćenja)

Doživite energiju španjolske prijestolnice kroz šetnje povijesnim trgovima, tapas kulturu i spektakularne rooftop terase. Ovaj city break vodi vas kroz najpoznatije dijelove Madrida te na izlet u bajkovitu Segoviu, grad poznat po rimskom akvaduktu i vrhunskoj gastronomiji. Putujemo direktnim letom iz Zagreba s aviokompanijom Iberia uz smještaj u apartmanima 3★ u centru Madrida. Tijekom cijelog putovanja grupu prati voditelj putovanja na hrvatskom i španjolskom jeziku.

📍 PROGRAM PUTOVANJA
1. DAN – ZAGREB – MADRID
Sastanak u zračnoj luci Franjo Tuđman. Direktan let za Madrid (prtljaga 10 kg uključena; 23 kg uz nadoplatu). Dolazak oko 14:00, transfer do apartmana u centru. Popodne: pješački razgled – Gran Vía, Plaza Mayor, Royal Palace of Madrid (razgled uz nadoplatu), Puerta del Sol, Mercado San Miguel. Večera u tapas barovima u La Latini; rooftop bar uključen u cijenu.

2. DAN – MADRID
Doručak u churreriji (churros i topla čokolada). Četvrt Salamanca, Calle de Serrano, Puerta de Alcalá, park El Retiro (opcionalno iznajmljivanje barke). Po želji uz nadoplatu: Prado Museum, Reina Sofía, stadion Santiago Bernabéu. Poslijepodne: kvart Chueca. Opcionalno: Flamenco show (nadoplata 50 €).

3. DAN – SEGOVIA
Izlet vlakom iz Chamartína u Segoviu. Šetnja romantičnim ulicama, ručak (Cochinillo asado i vino), razgled: Akvadukt u Segovii, Alcázar de Segovia, katedrala, Plaza Mayor. Povratak u Madrid; večera slobodna.

4. DAN – MADRID – ZAGREB
Doručak i kava, transfer na aerodrom. Jutarnji let Madrid–Zagreb.

🏨 SMJEŠTAJ
Apartmani 3★ u centru Madrida: potpuno opremljeni, privatna kupaonica, kuhinja, WiFi. Bez doručka.

💰 CIJENA ARANŽMANA UKLJUČUJE
• Povratni direktan let Zagreb–Madrid–Zagreb (Iberia) i aerodromske pristojbe
• Transfer aerodrom–smještaj–aerodrom
• 4 dana, 3 noćenja u apartmanima 3★ u centru Madrida
• Voditelj putovanja na hrvatskom i španjolskom
• Jednodnevni izlet vlakom u Segoviu

Ukupna cijena: 870,00 € po osobi

Zašto svibanj: ugodne temperature 20–25°C, park Retiro u punom sjaju, tapas na terasama, živa atmosfera Chuece i La Latine.

💳 UVJETI PLAĆANJA
Akontacija 40 % na HR7523400093207336956. Preostali iznos najkasnije 20 dana prije polaska.

📞 Rezervacije: info@linatravelina.eu | +385 91 214 447 7
TraveLina – putovanja koja se pamte!`,
        en: `MADRID & SEGOVIA – CITY BREAK
Tapas, Rooftops & Spanish Energy!

🗓 14–17 May (4 days / 3 nights)

Experience the energy of Spain's capital through historic squares, tapas culture and spectacular rooftop terraces. This city break takes you through Madrid's highlights and a day trip to fairy-tale Segovia, known for its Roman aqueduct and superb gastronomy. Direct Iberia flights from Zagreb; 3★ apartments in central Madrid. Tour leader in Croatian and Spanish throughout.

📍 PROGRAMME
Day 1 – Zagreb–Madrid: Meet at Zagreb Airport. Direct flight (10 kg luggage included; 23 kg supplement). Arrival ~14:00, transfer to central apartments. Afternoon walking tour: Gran Vía, Plaza Mayor, Royal Palace (optional supplement), Puerta del Sol, Mercado San Miguel. Evening tapas in La Latina; rooftop bar included.

Day 2 – Madrid: Churros and hot chocolate. Salamanca quarter, Calle de Serrano, Puerta de Alcalá, El Retiro Park (optional boat hire). Optional supplements: Prado Museum, Reina Sofía, Santiago Bernabéu Stadium. Afternoon: Chueca. Optional: Flamenco show (€50 supplement).

Day 3 – Segovia: Train from Chamartín to Segovia. Walk through the old town, lunch (Cochinillo asado and wine), aqueduct, Alcázar, cathedral, Plaza Mayor. Return to Madrid; evening free.

Day 4 – Madrid–Zagreb: Breakfast, transfer to airport, morning flight to Zagreb.

🏨 Accommodation: 3★ apartments in central Madrid (fully equipped, private bathroom, kitchen, WiFi). No breakfast.

💰 PRICE INCLUDES: Return flight Zagreb–Madrid–Zagreb (Iberia) and airport taxes; transfers; 4 days / 3 nights in 3★ apartments; tour leader (Croatian & Spanish); one-day train excursion to Segovia. Total: €870 per person.

💳 Payment: 40% deposit to HR7523400093207336956. Balance 20 days before departure.
📞 info@linatravelina.eu | +385 91 214 447 7 | TraveLina`,
        de: `MADRID & SEGOVIA – CITY BREAK
Tapas, Rooftops & spanische Energie!

🗓 14.–17. Mai (4 Tage / 3 Nächte)

Energie der spanischen Hauptstadt: historische Plätze, Tapas-Kultur und spektakuläre Dachterrassen. City Break durch Madrid plus Tagesausflug nach Segovia (römisches Aquädukt, Gastronomie). Direktflug Iberia ab Zagreb; 3★-Apartments im Zentrum. Reiseleiter auf Kroatisch und Spanisch.

Programm: Tag 1 Zagreb–Madrid (Gran Vía, Plaza Mayor, Puerta del Sol, Mercado San Miguel, Tapas La Latina, Rooftop inkl.). Tag 2 Madrid (Churros, Salamanca, Retiro, optional Prado/Reina Sofía/Bernabéu, Chueca, optional Flamenco +50 €). Tag 3 Segovia (Zug, Aquädukt, Alcázar, Kathedrale, Cochinillo asado). Tag 4 Rückflug Madrid–Zagreb.

Preis inkl. Flug, Transfers, 3 Nächte 3★, Reiseleitung, Segovia-Ausflug: 870 € p. P. Zahlung: 40 % Anzahlung, Rest 20 Tage vor Abreise.
📞 info@linatravelina.eu | +385 91 214 447 7 | TraveLina`,
        es: `MADRID & SEGOVIA – CITY BREAK
Tapas, Rooftops y energía española

🗓 14–17 mayo (4 días / 3 noches)

Energía de la capital: plazas históricas, cultura de tapas y terrazas con vistas. City break por Madrid y excursión a Segovia (acueducto romano, gastronomía). Vuelo directo Iberia desde Zagreb; apartamentos 3★ en el centro. Guía en croata y español.

Programa: Día 1 Zagreb–Madrid (Gran Vía, Plaza Mayor, Puerta del Sol, Mercado San Miguel, tapas en La Latina, rooftop incl.). Día 2 Madrid (churros, Salamanca, Retiro, opcional Prado/Reina Sofía/Bernabéu, Chueca, opcional flamenco +50 €). Día 3 Segovia (tren, acueducto, Alcázar, catedral, cochinillo asado). Día 4 Regreso Madrid–Zagreb.

Precio incl. vuelo, traslados, 3 noches 3★, guía, excursión a Segovia: 870 € por persona. Pago: 40 % depósito, resto 20 días antes de la salida.
📞 info@linatravelina.eu | +385 91 214 447 7 | TraveLina`,
      },
    },
    {
      id: 5,
      key: "valladolid-1tjedan",
      category: "city",
      days: 9,
      nights: 8,
      country: "Spain",
      date: "2026-08-22",
      price: 1790,
      tag: "New",
      image: "/images/valladolid.jpeg",
      blogText: { hr: "", en: "", de: "", es: "" },
      gallery: [
        "/images/valladolid.jpeg",
        ...VALLADOLID_GALLERY_DESKTOP,
        "/images/salamanca.jpg",
        "/images/segovia.jpg",
        "/images/segovia1.jpg",
      ],
      detailedInfo: {
        hr: `VALLADOLID – UČENJE ŠPANJOLSKOG JEZIKA
Intenzivni tečaj jezika, kulture i autentične španjolske atmosfere

🗓 22.08. – 30.08.2026. | 9 dana / 8 noći

Putovanje je namijenjeno svima koji žele učiti ili usavršiti španjolski u autentičnom okruženju. Program kombinira intenzivni tečaj u Valladolidu, upoznavanje španjolske kulture i gastronomije te izlete u povijesne gradove Castille i Leóna. Tijekom putovanja sudionicima je na raspolaganju voditelj na hrvatskom i španjolskom jeziku.

📍 PROGRAM PUTOVANJA

1. DAN – 22.08. ZAGREB – MADRID
Sastanak putnika u poslijepodnevnim satima u zračnoj luci Franjo Tuđman. Direktan let Zagreb – Madrid u večernjim satima. Dolazak u kasnim večernjim satima, transfer do smještaja i noćenje u Madridu (apartmani 3★).

2. DAN – 23.08. MADRID – VALLADOLID
Doručak u churreriji (churros s toplom čokoladom). Jutarnja šetnja povijesnim centrom Madrida: Gran Vía, Plaza Mayor, Puerta del Sol, Royal Palace of Madrid (ulaznice uz doplatu). U poslijepodnevnim satima odlazak vlakom prema Valladolidu. Dolazak, transfer do smještaja, odmor i šetnja gradom.

BORAVAK U VALLADOLIDU I UČENJE JEZIKA
Od ponedjeljka započinje tečaj španjolskog u jezičnom institutu u centru grada. Polaznici u grupama prema razini (početnici, srednja razina, napredni). Nastava u manjim grupama; međunarodna skupina polaznika – druženje i praksa jezika.

VALLADOLID – kultura i gastronomija
Nekadašnja prijestolnica Španjolske; elegantni trgovi, studentski život. Poznat po lechazu, tapasima i vinima Ribera del Duero i Rueda.

IZLETI UKLJUČENI U CIJENU
• Segovia – UNESCO, rimski akvadukt, Alcázar, katedrala, cochinillo asado.
• Salamanca – jedno od najstarijih sveučilišta u Europi, Plaza Mayor, zlatni pješčenjak.

OPCIJSKI IZLETI (nisu uključeni u cijenu)
Ávila (zidine), León (katedrala, San Isidoro). Posjeti vinarijama u Ribera del Duero i Rueda – uz doplatu.

ZAŠTO UČITI U VALLADOLIDU
Čist kastiljski izgovor, autentična atmosfera, polaznici iz cijelog svijeta, bogata gastronomija, idealna baza za izlete.

💰 CIJENA ARANŽMANA: 1.790,00 € po osobi

✅ CIJENA UKLJUČUJE
Povratni let Zagreb – Madrid – Zagreb • Aerodromske pristojbe • Transfer aerodrom – smještaj • 1 noćenje u Madridu (apartmani 3★) • Vlak Madrid – Valladolid – Madrid • Smještaj u Valladolidu tijekom programa • Tečaj španjolskog u institutu u centru • Izlet u Segoviu • Izlet u Salamancu • Organizacija • Voditelj putovanja (hr/es) tijekom programa

❌ CIJENA NE UKLJUČUJE
Opcijske izlete (Ávila, León) • Posjete vinarijama • Osobne troškove • Putno osiguranje

📞 Rezervacije: info@linatravelina.eu | +385 91 214 447 7
TraveLina – putovanja koja se pamte!`,
        en: `VALLADOLID – SPANISH LANGUAGE PROGRAM
Intensive course, culture and authentic Spain

🗓 22–30 Aug 2026 | 9 days / 8 nights

Learn or improve Spanish in Valladolid with a Madrid start, train transfer, language institute (groups by level), included excursions to Segovia and Salamanca, optional Ávila/León. Tour leader in Croatian and Spanish.

💰 €1,790 per person. Includes: return flights Zagreb–Madrid, taxes, transfers, 1 night Madrid 3★, train Madrid–Valladolid–Madrid, accommodation in Valladolid, course, Segovia & Salamanca trips, organisation, leader.

❌ Not included: optional tours, wineries, personal costs, insurance.
📞 info@linatravelina.eu | +385 91 214 447 7 | TraveLina`,
        de: `VALLADOLID – SPANISCHKURS
Intensiv, Kultur, authentisches Spanien

🗓 22.–30. Aug. 2026 | 9 Tage / 8 Nächte

Sprachkurs in Valladolid, Start in Madrid, Zug, Institut (Niveaugruppen), Ausflüge Segovia & Salamanca inkl. Optional Ávila/León. Reiseleitung KR/ES.

💰 1.790 € p. P. Inkl. Flug Zagreb–Madrid–Zagreb, Transfers, 1 Nacht Madrid 3★, Zug, Unterkunft Valladolid, Kurs, Ausflüge, Organisation.

📞 info@linatravelina.eu | +385 91 214 447 7 | TraveLina`,
        es: `VALLADOLID – CURSO DE ESPAÑOL
Intensivo, cultura y España auténtica

🗓 22–30 ago 2026 | 9 días / 8 noches

Curso en Valladolid, Madrid al inicio, tren, instituto por niveles, excursiones a Segovia y Salamanca incluidas. Guía en croata y español.

💰 1.790 € p. persona. Incluye vuelo Zagreb–Madrid, tasas, traslados, 1 noche Madrid 3★, tren, alojamiento Valladolid, curso, excursiones.

📞 info@linatravelina.eu | +385 91 214 447 7 | TraveLina`,
      },
    },
    {
      id: 6,
      key: "valladolid-2tjedan",
      category: "city",
      days: 14,
      nights: 13,
      country: "Spain",
      date: "2026-08-22",
      price: 2490,
      tag: "New",
      image: "/images/valladolid.jpeg",
      blogText: { hr: "", en: "", de: "", es: "" },
      gallery: [
        "/images/valladolid.jpeg",
        ...VALLADOLID_GALLERY_DESKTOP,
        "/images/salamanca.jpg",
        "/images/segovia.jpg",
        "/images/segovia1.jpg",
      ],
      detailedInfo: {
        hr: `VALLADOLID – UČENJE ŠPANJOLSKOG JEZIKA
14 dana jezika, kulture i autentične španjolske atmosfere

🗓 22.08. – 05.09.2026. | 14 dana / 13 noći

Putovanje je namijenjeno svima koji žele učiti ili usavršiti španjolski u autentičnom okruženju. Program kombinira intenzivni tečaj u Valladolidu (dva radna tjedna), upoznavanje kulture i gastronomije te izlete u povijesne gradove Castille i Leóna. Voditelj putovanja na hrvatskom i španjolskom jeziku uz vas je tijekom cijelog programa.

📍 PROGRAM PUTOVANJA

1. DAN – 22.08. ZAGREB – MADRID
Sastanak putnika u poslijepodnevnim satima u zračnoj luci Franjo Tuđman. Direktan let Zagreb – Madrid u večernjim satima. Dolazak u kasnim večernjim satima, transfer do smještaja i noćenje u Madridu (apartmani 3★).

2. DAN – 23.08. MADRID – VALLADOLID
Doručak u jednoj od najstarijih churrerija (churros s toplom čokoladom). Jutarnja šetnja centrom: Gran Vía, Plaza Mayor, Puerta del Sol, Royal Palace of Madrid (ulaznice uz doplatu). U poslijepodnevnim satima vlakom u Valladolid. Dolazak, transfer do smještaja, odmor i šetnja gradom.

BORAVAK U VALLADOLIDU I UČENJE JEZIKA
Od ponedjeljka započinje tečaj španjolskog u jezičnom institutu u centru grada. Polaznici u grupama prema razini (početnici, srednja razina, napredni). Nastava u manjim grupama; međunarodna skupina – druženje i praksa jezika svakodnevno (polaznici od mlađih do starijih, iz cijelog svijeta).

Dva uzastopna radna tjedna učvršćuju jezik i komunikaciju u autentičnom okruženju. Izleti u Segoviu i Salamancu uključeni su tijekom boravka (prema rasporedu instituta i grupe).

ZAVRŠETAK I POVRATAK
Organiziran odlazak vlakom Valladolid – Madrid i povratni let Madrid – Zagreb u skladu s konačnim rasporedom prijevoza (često isti dan; do 05.09.2026.).

VALLADOLID – kultura i gastronomija
Nekadašnja prijestolnica Španjolske; elegantni trgovi, studentski život. Poznat po lechazu, tapasima i vinima Ribera del Duero i Rueda.

IZLETI UKLJUČENI U CIJENU
• Segovia – UNESCO, rimski akvadukt, Alcázar, katedrala, cochinillo asado.
• Salamanca – jedno od najstarijih sveučilišta u Europi, Plaza Mayor, zlatni pješčenjak.

OPCIJSKI IZLETI (nisu uključeni u cijenu)
Ávila (zidine), León (katedrala, San Isidoro). Posjeti vinarijama u Ribera del Duero i Rueda – uz doplatu.

ZAŠTO UČITI U VALLADOLIDU
Čist kastiljski izgovor • autentična atmosfera • polaznici iz cijelog svijeta • bogata gastronomija • idealna baza za izlete u Castillu

💰 CIJENA ARANŽMANA: 2.490,00 € po osobi

✅ CIJENA UKLJUČUJE
Povratni let Zagreb – Madrid – Zagreb • Aerodromske pristojbe • Transfer aerodrom – smještaj • 1 noćenje u Madridu (apartmani 3★) • Karta za vlak Madrid – Valladolid – Madrid • Smještaj u Valladolidu tijekom programa • Tečaj španjolskog u institutu u centru • Izlet u Segoviu • Izlet u Salamancu • Organizacija • Voditelj putovanja (hr/es) tijekom cijelog programa

❌ CIJENA NE UKLJUČUJE
Opcijske izlete (Ávila, León) • Posjete vinarijama • Osobne troškove • Putno osiguranje

📞 Rezervacije: info@linatravelina.eu | +385 91 214 447 7
TraveLina – putovanja koja se pamte!`,
        en: `VALLADOLID – SPANISH (2 WEEKS)
Language, culture and authentic Spain

🗓 22 Aug – 5 Sep 2026 | 14 days / 13 nights

Intensive Spanish in Valladolid over two teaching weeks, with a Madrid start, train transfer, institute (groups by level), included excursions to Segovia and Salamanca. Optional Ávila/León and wineries. Tour leader in Croatian and Spanish throughout.

Return: train Valladolid–Madrid and flight Madrid–Zagreb per carrier schedule (often same day; by 5 Sep 2026).

💰 €2,490 per person. Includes: return flights Zagreb–Madrid, taxes, transfers, 1 night Madrid 3★, train tickets Madrid–Valladolid–Madrid, accommodation in Valladolid, course, Segovia & Salamanca trips, organisation, leader.

❌ Not included: optional tours, wineries, personal costs, insurance.
📞 info@linatravelina.eu | +385 91 214 447 7 | TraveLina`,
        de: `VALLADOLID – SPANISCHKURS (2 WOCHEN)
Sprache, Kultur, authentisches Spanien

🗓 22.08.–05.09.2026 | 14 Tage / 13 Nächte

Intensivkurs in Valladolid über zwei Unterrichtswochen, Start in Madrid, Zug, Institut (Niveaugruppen), Ausflüge Segovia & Salamanca inkl. Optional Ávila/León, Weingüter. Reiseleitung KR/ES während des gesamten Programms.

Rückreise: Zug Valladolid–Madrid und Flug Madrid–Zagreb gemäß Flugplan (oft am selben Tag; bis 05.09.2026).

💰 2.490 € p. P. Inkl. Flug Zagreb–Madrid–Zagreb, Transfers, 1 Nacht Madrid 3★, Zugtickets, Unterkunft Valladolid, Kurs, Ausflüge, Organisation, Leitung.

📞 info@linatravelina.eu | +385 91 214 447 7 | TraveLina`,
        es: `VALLADOLID – ESPAÑOL (2 SEMANAS)
Idioma, cultura y España auténtica

🗓 22 ago – 5 sep 2026 | 14 días / 13 noches

Curso intensivo en Valladolid durante dos semanas lectivas, Madrid al inicio, tren, instituto por niveles, excursiones a Segovia y Salamanca incluidas. Opcional Ávila/León y bodegas. Guía en croata y español durante todo el programa.

Regreso: tren Valladolid–Madrid y vuelo Madrid–Zagreb según horarios (a menudo el mismo día; hasta 5 sep 2026).

💰 2.490 € por persona. Incluye vuelo Zagreb–Madrid, tasas, traslados, 1 noche Madrid 3★, billetes de tren, alojamiento Valladolid, curso, excursiones, organización, guía.

📞 info@linatravelina.eu | +385 91 214 447 7 | TraveLina`,
      },
    },
    {
      id: 10,
      key: "valladolid-1tjedan-lipanj",
      category: "city",
      days: 9,
      nights: 8,
      country: "Spain",
      date: "2026-06-13",
      price: 1790,
      tag: "Last Minute",
      image: "/images/valladolid.jpeg",
      blogText: { hr: "", en: "", de: "", es: "" },
      gallery: [
        "/images/valladolid.jpeg",
        ...VALLADOLID_GALLERY_DESKTOP,
        "/images/salamanca.jpg",
        "/images/segovia.jpg",
        "/images/segovia1.jpg",
      ],
      detailedInfo: {
        hr: `Valladolid učenje španjolskog jezika
Intenzivni tečaj jezika, kulture i autentične španjolske atmosfere

🗓 13.06. – 21.06.2026. | 9 dana / 8 noći

Putovanje je namijenjeno svima koji žele učiti ili usavršiti španjolski u autentičnom okruženju. Program kombinira intenzivni tečaj u Valladolidu, upoznavanje španjolske kulture i gastronomije te izlete u povijesne gradove Castille i Leóna. Tijekom putovanja sudionicima je na raspolaganju voditelj na hrvatskom i španjolskom jeziku.

📍 PROGRAM PUTOVANJA

1. DAN – 13.06. ZAGREB – MADRID
Sastanak putnika u poslijepodnevnim satima u zračnoj luci Franjo Tuđman. Direktan let Zagreb – Madrid u večernjim satima. Dolazak u kasnim večernjim satima, transfer do smještaja i noćenje u Madridu (apartmani 3★).

2. DAN – 14.06. MADRID – VALLADOLID
Doručak u churreriji (churros s toplom čokoladom). Jutarnja šetnja povijesnim centrom Madrida: Gran Vía, Plaza Mayor, Puerta del Sol, Royal Palace of Madrid (ulaznice uz doplatu). U poslijepodnevnim satima odlazak vlakom prema Valladolidu. Dolazak, transfer do smještaja, odmor i šetnja gradom.

BORAVAK U VALLADOLIDU I UČENJE JEZIKA
Od ponedjeljka 15.06. započinje tečaj španjolskog u jezičnom institutu u centru grada. Polaznici u grupama prema razini (početnici, srednja razina, napredni). Nastava u manjim grupama; međunarodna skupina polaznika – druženje i praksa jezika.

ZAVRŠETAK I POVRATAK
Organiziran povratni let Madrid – Zagreb u skladu s konačnim rasporedom prijevoza (21.06.2026.).

VALLADOLID – kultura i gastronomija
Nekadašnja prijestolnica Španjolske; elegantni trgovi, studentski život. Poznat po lechazu, tapasima i vinima Ribera del Duero i Rueda.

IZLETI UKLJUČENI U CIJENU
• Segovia – UNESCO, rimski akvadukt, Alcázar, katedrala, cochinillo asado.
• Salamanca – jedno od najstarijih sveučilišta u Europi, Plaza Mayor, zlatni pješčenjak.

OPCIJSKI IZLETI (nisu uključeni u cijenu)
Ávila (zidine), León (katedrala, San Isidoro). Posjeti vinarijama u Ribera del Duero i Rueda – uz doplatu.

ZAŠTO UČITI U VALLADOLIDU
Čist kastiljski izgovor, autentična atmosfera, polaznici iz cijelog svijeta, bogata gastronomija, idealna baza za izlete.

💰 Cijena aranžmana: 1.790,00 € po osobi

✅ CIJENA UKLJUČUJE
Povratni let Zagreb – Madrid – Zagreb • Aerodromske pristojbe • Transfer aerodrom – smještaj • 1 noćenje u Madridu (apartmani 3★) • Vlak Madrid – Valladolid – Madrid • Smještaj u Valladolidu tijekom programa • Tečaj španjolskog u institutu u centru • Izlet u Segoviu • Izlet u Salamancu • Organizacija • Voditelj putovanja (hr/es) tijekom programa

❌ CIJENA NE UKLJUČUJE
Opcijske izlete (Ávila, León) • Posjete vinarijama • Osobne troškove • Putno osiguranje

📞 Rezervacije: info@linatravelina.eu | +385 91 214 447 7
TraveLina – putovanja koja se pamte!`,
        en: `Valladolid – Spanish language course
Intensive course, culture and authentic Spain

🗓 13–21 Jun 2026 | 9 days / 8 nights

Learn or improve Spanish in Valladolid with a Madrid start, train transfer, language institute (groups by level), included excursions to Segovia and Salamanca, optional Ávila/León. Tour leader in Croatian and Spanish.

💰 €1,790 per person. Includes: return flights Zagreb–Madrid, taxes, transfers, 1 night Madrid 3★, train Madrid–Valladolid–Madrid, accommodation in Valladolid, course, Segovia & Salamanca trips, organisation, leader.

❌ Not included: optional tours, wineries, personal costs, insurance.
📞 info@linatravelina.eu | +385 91 214 447 7 | TraveLina`,
        de: `Valladolid – Spanischkurs
Intensiv, Kultur, authentisches Spanien

🗓 13.–21. Juni 2026 | 9 Tage / 8 Nächte

Sprachkurs in Valladolid, Start in Madrid, Zug, Institut (Niveaugruppen), Ausflüge Segovia & Salamanca inkl. Optional Ávila/León. Reiseleitung KR/ES.

💰 1.790 € p. P. Inkl. Flug Zagreb–Madrid–Zagreb, Transfers, 1 Nacht Madrid 3★, Zug, Unterkunft Valladolid, Kurs, Ausflüge, Organisation.

📞 info@linatravelina.eu | +385 91 214 447 7 | TraveLina`,
        es: `Valladolid – curso de español
Intensivo, cultura y España auténtica

🗓 13–21 jun 2026 | 9 días / 8 noches

Curso en Valladolid, Madrid al inicio, tren, instituto por niveles, excursiones a Segovia y Salamanca incluidas. Guía en croata y español.

💰 1.790 € p. persona. Incluye vuelo Zagreb–Madrid, tasas, traslados, 1 noche Madrid 3★, tren, alojamiento Valladolid, curso, excursiones.

📞 info@linatravelina.eu | +385 91 214 447 7 | TraveLina`,
      },
    },
    {
      id: 11,
      key: "valladolid-2tjedan-lipanj",
      category: "city",
      days: 14,
      nights: 13,
      country: "Spain",
      date: "2026-06-13",
      price: 2490,
      tag: "Last Minute",
      image: "/images/valladolid.jpeg",
      blogText: { hr: "", en: "", de: "", es: "" },
      gallery: [
        "/images/valladolid.jpeg",
        ...VALLADOLID_GALLERY_DESKTOP,
        "/images/salamanca.jpg",
        "/images/segovia.jpg",
        "/images/segovia1.jpg",
      ],
      detailedInfo: {
        hr: `Valladolid učenje španjolskog jezika
14 dana jezika, kulture i autentične španjolske atmosfere

🗓 13.06. – 27.06.2026. | 14 dana / 13 noći

Putovanje je namijenjeno svima koji žele učiti ili usavršiti španjolski u autentičnom okruženju. Program kombinira intenzivni tečaj u Valladolidu (dva radna tjedna), upoznavanje kulture i gastronomije te izlete u povijesne gradove Castille i Leóna. Voditelj putovanja na hrvatskom i španjolskom jeziku uz vas je tijekom cijelog programa.

📍 PROGRAM PUTOVANJA

1. DAN – 13.06. ZAGREB – MADRID
Sastanak putnika u poslijepodnevnim satima u zračnoj luci Franjo Tuđman. Direktan let Zagreb – Madrid u večernjim satima. Dolazak u kasnim večernjim satima, transfer do smještaja i noćenje u Madridu (apartmani 3★).

2. DAN – 14.06. MADRID – VALLADOLID
Doručak u jednoj od najstarijih churrerija (churros s toplom čokoladom). Jutarnja šetnja centrom: Gran Vía, Plaza Mayor, Puerta del Sol, Royal Palace of Madrid (ulaznice uz doplatu). U poslijepodnevnim satima vlakom u Valladolid. Dolazak, transfer do smještaja, odmor i šetnja gradom.

BORAVAK U VALLADOLIDU I UČENJE JEZIKA
Od ponedjeljka 15.06. započinje tečaj španjolskog u jezičnom institutu u centru grada. Polaznici u grupama prema razini (početnici, srednja razina, napredni). Nastava u manjim grupama; međunarodna skupina – druženje i praksa jezika svakodnevno (polaznici od mlađih do starijih, iz cijelog svijeta).

Dva uzastopna radna tjedna učvršćuju jezik i komunikaciju u autentičnom okruženju. Izleti u Segoviu i Salamancu uključeni su tijekom boravka (prema rasporedu instituta i grupe).

ZAVRŠETAK I POVRATAK
Organiziran odlazak vlakom Valladolid – Madrid i povratni let Madrid – Zagreb u skladu s konačnim rasporedom prijevoza (do 27.06.2026.).

VALLADOLID – kultura i gastronomija
Nekadašnja prijestolnica Španjolske; elegantni trgovi, studentski život. Poznat po lechazu, tapasima i vinima Ribera del Duero i Rueda.

IZLETI UKLJUČENI U CIJENU
• Segovia – UNESCO, rimski akvadukt, Alcázar, katedrala, cochinillo asado.
• Salamanca – jedno od najstarijih sveučilišta u Europi, Plaza Mayor, zlatni pješčenjak.

OPCIJSKI IZLETI (nisu uključeni u cijenu)
Ávila (zidine), León (katedrala, San Isidoro). Posjeti vinarijama u Ribera del Duero i Rueda – uz doplatu.

ZAŠTO UČITI U VALLADOLIDU
Čist kastiljski izgovor • autentična atmosfera • polaznici iz cijelog svijeta • bogata gastronomija • idealna baza za izlete u Castillu

💰 Cijena aranžmana (dva tjedna): 2.490,00 € po osobi

✅ CIJENA UKLJUČUJE
Povratni let Zagreb – Madrid – Zagreb • Aerodromske pristojbe • Transfer aerodrom – smještaj • 1 noćenje u Madridu (apartmani 3★) • Karta za vlak Madrid – Valladolid – Madrid • Smještaj u Valladolidu tijekom programa • Tečaj španjolskog u institutu u centru • Izlet u Segoviu • Izlet u Salamancu • Organizacija • Voditelj putovanja (hr/es) tijekom cijelog programa

❌ CIJENA NE UKLJUČUJE
Opcijske izlete (Ávila, León) • Posjete vinarijama • Osobne troškove • Putno osiguranje

📞 Rezervacije: info@linatravelina.eu | +385 91 214 447 7
TraveLina – putovanja koja se pamte!`,
        en: `Valladolid – Spanish language course (two weeks)
Language, culture and authentic Spain

🗓 13–27 Jun 2026 | 14 days / 13 nights

Intensive Spanish in Valladolid over two teaching weeks, with a Madrid start, train transfer, institute (groups by level), included excursions to Segovia and Salamanca. Optional Ávila/León and wineries. Tour leader in Croatian and Spanish throughout.

Return: train Valladolid–Madrid and flight Madrid–Zagreb per carrier schedule (by 27 Jun 2026).

💰 €2,490 per person. Includes: return flights Zagreb–Madrid, taxes, transfers, 1 night Madrid 3★, train tickets Madrid–Valladolid–Madrid, accommodation in Valladolid, course, Segovia & Salamanca trips, organisation, leader.

❌ Not included: optional tours, wineries, personal costs, insurance.
📞 info@linatravelina.eu | +385 91 214 447 7 | TraveLina`,
        de: `Valladolid – Spanischkurs (zwei Wochen)
Sprache, Kultur, authentisches Spanien

🗓 13.–27. Juni 2026 | 14 Tage / 13 Nächte

Intensivkurs in Valladolid über zwei Unterrichtswochen, Start in Madrid, Zug, Institut (Niveaugruppen), Ausflüge Segovia & Salamanca inkl. Optional Ávila/León, Weingüter. Reiseleitung KR/ES während des gesamten Programms.

Rückreise: Zug Valladolid–Madrid und Flug Madrid–Zagreb gemäß Flugplan (bis 27.06.2026).

💰 2.490 € p. P. Inkl. Flug Zagreb–Madrid–Zagreb, Transfers, 1 Nacht Madrid 3★, Zugtickets, Unterkunft Valladolid, Kurs, Ausflüge, Organisation, Leitung.

📞 info@linatravelina.eu | +385 91 214 447 7 | TraveLina`,
        es: `Valladolid – curso de español (dos semanas)
Idioma, cultura y España auténtica

🗓 13–27 jun 2026 | 14 días / 13 noches

Curso intensivo en Valladolid durante dos semanas lectivas, Madrid al inicio, tren, instituto por niveles, excursiones a Segovia y Salamanca incluidas. Opcional Ávila/León y bodegas. Guía en croata y español durante todo el programa.

Regreso: tren Valladolid–Madrid y vuelo Madrid–Zagreb según horarios (hasta 27 jun 2026).

💰 2.490 € por persona. Incluye vuelo Zagreb–Madrid, tasas, traslados, 1 noche Madrid 3★, billetes de tren, alojamiento Valladolid, curso, excursiones, organización, guía.

📞 info@linatravelina.eu | +385 91 214 447 7 | TraveLina`,
      },
    },
    {
      id: 9,
      key: "od-madrida-do-vinograda",
      category: "city",
      days: 6,
      nights: 5,
      country: "Spain",
      date: "2026-09-10",
      price: 1290,
      tag: "New",
      image: "/images/madrid-vinograda/1000149586.jpg",
      blogText: { hr: "", en: "", de: "", es: "" },
      gallery: [...MADRID_VINOGRADA_GALLERY_DESKTOP],
      detailedInfo: {
        hr: MADRID_VINOGRADA_HR_DETAILED_INFO,
        en: MADRID_VINOGRADA_EN_DETAILED_INFO,
        de: MADRID_VINOGRADA_DE_DETAILED_INFO,
        es: MADRID_VINOGRADA_ES_DETAILED_INFO,
      },
    },
    VALENCIA_TOUR,
  ];
  return ensureValladolidTourTranslations(
    ensureFullDetailedInfoByLanguage(
      ensureMadridJuneTours(
        mergeMadridVinogradaIfMissing(
          mergeAlicanteListopadIfMissing(defaultTours, ALICANTE_TOUR_GALLERY_BUILTIN),
          MADRID_VINOGRADA_GALLERY_DESKTOP
        )
      )
    )
  );
};

export let tours = loadTours();

// Funkcija za spremanje u localStorage
export const saveTours = (updatedTours) => {
  tours = updatedTours;
  localStorage.setItem("travelina_tours", JSON.stringify(updatedTours));
};
